'use client';
import { useEffect, useState } from 'react';
import AppImage from '@/components/ui/AppImage';

const carouselImages = [
{
  id: 'hero_carousel_1',
  src: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86",
  alt: 'Abstract data visualization with colorful charts and graphs on dark background'
},
{
  id: 'hero_carousel_2',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_13d8862bb-1769011162451.png",
  alt: 'Digital dashboard displaying analytics and metrics on computer screens'
},
{
  id: 'hero_carousel_3',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_14a588fdf-1768602824083.png",
  alt: 'Modern office workspace with laptop showing data spreadsheets'
}];


export default function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute inset-0 z-0">
      {carouselImages.map((image, index) =>
      <div
        key={image.id}
        className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}>
        
          <AppImage
          src={image.src}
          alt={image.alt}
          className="w-full h-full object-cover opacity-30 mix-blend-overlay"
          priority={index === 0} />
        
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/10 z-10 pointer-events-none" />
    </div>);

}